(function($){
  $(function() {
    var $searchResults = $('.search-results');

    if ($searchResults.length) {
      var searchResults = (function() {
        var $toggleButton = $searchResults.find('aside .toggle-btn');
        
        var handleFilterItemsDropdwon = function(e) {
          e. stopPropagation();

          $(this).toggleClass('toggle-btn--active');
          $(this).closest('aside').find('.filter-items__wrapper').slideToggle(300);
        }

        return {
          init: function() {
            this.bindEvents();
          },
          bindEvents: function() {
            $toggleButton.on('click', handleFilterItemsDropdwon);
          },
        }
      })();

      searchResults.init();
    }
  });
})(jQuery);